import React from "react";
import { useTranslation } from "react-i18next";
import Div from "@jumbo/shared/Div";
import PriceCalculatorForm from "./components/PriceCalculatorForm";
import PriceCalculatorLayout from "./PriceCalculatorLayout";

const PriceCalculatorPage = () => {
  const { t } = useTranslation();

  return (
    <PriceCalculatorLayout>
      <Div>
        <PriceCalculatorForm />
      </Div>
    </PriceCalculatorLayout>
  );
};

export default PriceCalculatorPage;
